module.exports = __webpack_public_path__ + "img/25-bronco.445017ab.png";